// extracted by mini-css-extract-plugin
export default {"wrap":"W1CRB","wrap__text":"sR39E","wrap__button":"qWL9G","animate-text":"ksDsc","fade-in":"mdMNU","animate-button":"YyErb","wrap__fade-out":"ZLTk3","fade-out":"lzOTx"};